import React from "react";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import officeColleagueOne from '../img/officeColleagueOne.jpg';
 import './OurCommitments.css'
import MissionValuesVisionCombined from '../img/banner/values.jpg';



// import OurValuesHandPik from '../img/banner/values.jpg';
// import ourVisionCardRed1 from '../img/banner/Vision.png';
// import ourMissionCardRed2 from '../img/banner/Mission.png';


import OurValuesHandPik from '../img/envision/aerospace/tabsimages/bfsidataprotaction.jpg';
import ourVisionCardRed1 from '../img/envision/aerospace/tabsimages/bfsidataprotaction.jpg';
import ourMissionCardRed2 from '../img/envision/aerospace/tabsimages/bfsidataprotaction.jpg';

// import OurValuesHandPik from '../img/banner/OurValues.png';
// import ourVisionCardRed1 from '../img/banner/OurVision.png';
// import ourMissionCardRed2 from '../img/banner/OurMission.png';




const OurCommitments = () => {
  return (
    <div style={{ marginBottom:'50px' }}>
      <div className="text-center">
      <h1 style={{ color: "#000", fontSize: '48px', display: 'inline-block', position: 'relative' }}>
                       Our <span style={{ color: "#f7941d" }}>Commitments</span>
                       <span style={{
                         position: 'absolute',
                         bottom: '-8px',
                         left: '50%',
                         transform: 'translateX(-50%)',
                         width: '50%',
                         height: '2px',
                         backgroundColor: '#000'
                       }} />
                     </h1>
      </div>
      <div className="wrapper">
        <div className="row d-flex justify-content-center">
          <div className="col-lg-3" style={{margin:'20px 40px'}}>
            <div className="card">
              <img src={ourVisionCardRed1} alt="Our Vision" />
              <div className="info" style={{
                display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center',
                justifyContent: 'center', height: '100%'
              }}>
                
                <p style={{ fontSize: '16px' }}> At IIA Learning Institute, we envision a world where education empowers individuals to unlock their full potential. We strive to inspire innovation, creativity, and leadership, shaping a brighter future for all. Our commitment is to transform lives through knowledge, fostering a generation that drives meaningful change.</p>
                
              </div>
            </div>
          </div>

          <div className="col-lg-3" style={{margin:'20px 40px'}}>
            <div className="card">
              <img src={ourMissionCardRed2} alt="Our Mission" />
              <div className="info" style={{
                display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center',
                justifyContent: 'center', height: '100%'
              }}>
                
                <p  style={{ fontSize: '16px' }}>Our mission is to provide high-quality, dynamic learning experiences that empower individuals to grow personally and professionally. We blend theory with practical skills, helping students excel in their fields and tackle future challenges with confidence and resilience.</p>
               
              </div>
            </div>
          </div>

          <div className="col-lg-3" style={{margin:'20px 40px'}}>
            <div className="card">
              <img src={OurValuesHandPik} alt="Our Values" />
              <div className="info" style={{
                display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center',
                justifyContent: 'center', height: '100%'
              }}>
                <p  style={{ fontSize: '16px' }}>We are guided by integrity, innovation, and collaboration. We uphold the highest ethical standards, encourage innovative thinking, and foster a community where diverse perspectives thrive, creating an environment of continuous learning and growth.</p>
              </div>
               
              </div>
            </div>
          </div>
        </div>
      </div>
   
  );
};

export default OurCommitments;

// import React from 'react';

// const OurCommitments = () => {
//   return (
//     <section id="commitment" style={{ paddingTop: '40px' }}>
//       <div className="container">
//         <div className="row">
//           <section id="cards-containers" style={{ textAlign: 'center' }}>
//             <div className="container">
//               <h1
//                 style={{
//                   color: "#000",
//                   fontSize: "48px",
//                   display: "inline-block",
//                   position: "relative",
//                   fontFamily: "lato,sans,serif",
//                 }}
//               >
//                 Our <span style={{ color: "#3395AD" }}>Commitments</span>
//                 <span
//                   style={{
//                     position: "absolute",
//                     bottom: "-8px",
//                     left: "50%",
//                     transform: "translateX(-50%)",
//                     width: "50%",
//                     height: "2px",
//                     backgroundColor: "#000",
//                   }}
//                 />
//               </h1>
//             </div>

//             {/* Cards */}
//             <div className="cards-wrapper">
//               {/* Our Vision Card */}
//               <div className="cards">
//                 <div className="card-tops">
//                   <div className="icon">
//                     <i className="fa fa-crosshairs"></i>
//                   </div>
//                 </div>
//                 <div className="card-content">
//                   <h4>Our Vision</h4>
//                   <p>
//                     Our vision is to be the premier provider of integrated
//                     technology solutions, driving innovation and transformation
//                     for businesses worldwide.
//                   </p>
//                 </div>
//               </div>

//               {/* Our Mission Card */}
//               <div className="cards">
//                 <div className="card-tops">
//                   <div className="icon">
//                     <i className="fa fa-bullseye"></i>
//                   </div>
//                 </div>
//                 <div className="card-content">
//                   <h4>Our Mission</h4>
//                   <p>
//                     Our mission is to empower organizations by delivering
//                     customized, cutting-edge technology solutions that drive
//                     growth, enhance efficiency, and foster innovation.
//                   </p>
//                 </div>
//               </div>

//               {/* Our Values Card */}
//               <div className="cards">
//                 <div className="card-tops">
//                   <div className="icon">
//                     <i className="fa fa-heart"></i>
//                   </div>
//                 </div>
//                 <div className="card-content">
//                   <h4>Our Values</h4>
//                   <p>
//                     Innovation, Integrity, Collaboration, Customer-Centricity,
//                     Excellence, Sustainability, Adaptability.
//                   </p>
//                 </div>
//               </div>
//             </div>
//           </section>
//         </div>
//       </div>

//       {/* CSS */}
//       <style jsx>{`
//         .cards-wrapper {
//           display: flex;
//           justify-content: center;
//           gap: 20px;
//           flex-wrap: wrap;
//         }

//         .cards {
//           width: 250px;
//           height: 400px;
//           background: linear-gradient(135deg, #8ae5a1, #3395ad);
//           border-radious:150px 0px 150px 0px;
         

//           box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
//           overflow: hidden;
//           display: flex;
//           flex-direction: column;
//           align-items: center;
//           justify-content: flex-start;
//           transition: transform 0.3s, box-shadow 0.3s;
//         }

//         .cards:hover {
//           transform: scale(1.05);
//           box-shadow: 0 6px 15px rgba(0, 0, 0, 0.3);
//         }

//         .card-tops {
//           width: 100%;
//           height: 150px;
//           background-color: #fff;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//         }

//         .icon {
//           font-size: 48px;
//           color: #363435;
//         }

//         .card-content {
//           text-align: center;
//           padding: 20px;
//         }

//         .card-content h4 {
//           margin-bottom: 10px;
//           font-size: 20px;
//           color: #fff;
//         }

//         .card-content p {
//           font-size: 14px;
//           color: #e0e0e0;
//           line-height: 1.6;
//         }
//       `}</style>
//     </section>
//   );
// };

// export default OurCommitments;

